/**
 * A helper service for exporting files
 */
export class FileExporterUtilitiesService {

  /**
   * Converts binary string to array buffer before conversion to blob
   * https://github.com/SheetJS/js-xlsx
   *
   * @param string The input binary string
   *
   * @returns an array buffer ready for converting to blob
   */
  public convertBinaryStringToBuffer(str: string) {
    const buffer = new ArrayBuffer(str.length);
    const view = new Uint8Array(buffer);

    for (let i = 0; i < str.length; ++i) {
      // tslint:disable-next-line
      view[i] = str.charCodeAt(i) & 0xFF;
    }

    return buffer;
  }
}